import { render, staticRenderFns } from "./ModalAlertasSocioambientais.vue?vue&type=template&id=4204f91c&lang=pug"
import script from "./ModalAlertasSocioambientais.vue?vue&type=script&lang=js"
export * from "./ModalAlertasSocioambientais.vue?vue&type=script&lang=js"
import style0 from "./ModalAlertasSocioambientais.vue?vue&type=style&index=0&id=4204f91c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports